import { C } from "../constants/colors";
import { Card, Btn } from "../components/ui";

export default function Login({auth}){
  const {loginEmail,setLoginEmail,loginPassword,setLoginPassword,loginError,setLoginError,loginLoading,handleLogin}=auth;
  const fieldStyle={width:"100%",padding:"10px 12px",borderRadius:8,border:`1.5px solid ${C.border}`,fontSize:14,color:C.text,outline:"none",boxSizing:"border-box",marginBottom:16,background:C.white};
  return(
    <div style={{minHeight:"100vh",background:C.sand,display:"flex",alignItems:"center",justifyContent:"center",padding:24}}>
      <div style={{width:"100%",maxWidth:400}}>
        <div style={{textAlign:"center",marginBottom:32}}>
          <div style={{width:44,height:44,borderRadius:10,background:C.navy,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:800,color:C.white,fontSize:16,margin:"0 auto 16px"}}>WF</div>
          <div style={{fontWeight:800,fontSize:22,color:C.navy}}>Waste Free Tahoe</div>
          <div style={{color:C.muted,fontSize:13,marginTop:4}}>Waste Audit Tool</div>
        </div>
        <Card>
          <div style={{fontWeight:600,color:C.navy,marginBottom:20,fontSize:15}}>Sign in to continue</div>
          <label style={{display:"block",fontSize:11,fontWeight:600,color:C.muted,marginBottom:5,letterSpacing:0.5,textTransform:"uppercase"}}>Email</label>
          <input type="email" value={loginEmail} autoFocus
            onChange={e=>{setLoginEmail(e.target.value);setLoginError("");}}
            onKeyDown={e=>{if(e.key==="Enter")handleLogin();}}
            placeholder="you@example.com"
            style={fieldStyle}
          />
          <label style={{display:"block",fontSize:11,fontWeight:600,color:C.muted,marginBottom:5,letterSpacing:0.5,textTransform:"uppercase"}}>Password</label>
          <input type="password" value={loginPassword}
            onChange={e=>{setLoginPassword(e.target.value);setLoginError("");}}
            onKeyDown={e=>{if(e.key==="Enter")handleLogin();}}
            placeholder="Password"
            style={{...fieldStyle,border:`1.5px solid ${loginError?C.red:C.border}`,marginBottom:loginError?8:20}}
          />
          {loginError&&<div style={{color:C.red,fontSize:13,marginBottom:16}}>{loginError}</div>}
          <Btn onClick={handleLogin} disabled={loginLoading} style={{width:"100%"}}>{loginLoading?"Signing in…":"Sign in →"}</Btn>
        </Card>
      </div>
    </div>
  );
}
